
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { COMMON_ASPECT_RATIOS } from '../../../../../../config/layoutConstants';
import { Button } from '../../../../../../components/ui/Button';
import { useLocation } from 'react-router-dom';

// مجموعة ألوان جميلة وعشوائية للمناطق
const AREA_PALETTE = [
    '#ef4444', // red
    '#f97316', // orange
    '#f59e0b', // amber
    '#84cc16', // lime
    '#22c55e', // green
    '#14b8a6', // teal
    '#06b6d4', // cyan
    '#3b82f6', // blue
    '#8b5cf6', // violet
    '#d946ef', // fuchsia
    '#ec4899', // pink
    '#64748b', // slate
    '#0ea5e9', // sky
    '#10b981', // emerald
    '#a855f7', // purple
    '#fb923c', // coral
];

const getRandomColor = () => {
    return AREA_PALETTE[Math.floor(Math.random() * AREA_PALETTE.length)];
};

const DEFAULT_OPACITY = 0.4; // 40% opacity افتراضي

const AddArea = ({ currentAspectRatio, setAreas, areas, setAreaColor = null, setAreaOpacity = null }) => {
    const { t } = useTranslation();
    const unit = useSelector((state) => state.layout.unit);
    const location = useLocation();
    const isAnimatedLayout = location.pathname.startsWith('/apps/animated_layouts');

    const handleAddArea = () => {
        const usedNumbers = new Set();
        
        areas.forEach(area => {
            const idNum = parseInt(area.id, 10);
            const orderNum = parseInt(area.order, 10);
            
            if (!isNaN(idNum)) usedNumbers.add(idNum);
            if (!isNaN(orderNum)) usedNumbers.add(orderNum);
        });

        let newId = 1;
        while (usedNumbers.has(newId)) {
            newId++;
        }

        // توليد لون عشوائي
        const randomColor = getRandomColor();

        if (unit.value == "%") {
            const newArea = {
                unit: "%",
                id: newId,
                name: isAnimatedLayout ? `Ad Slot ${newId}` : `Screen ${newId}`,
                start_margin: 0,
                top_margin: 0,
                width: 100,
                height: 100,
                order: newId,
                settings: {
                    live: {
                        is_muted: 0,
                        maintain_aspect_ratio: 1,
                        order: newId,
                        media_animation: {
                            type: "FADE",
                            enabled: false,
                            duration: 0.5,
                            direction: "CENTER"
                        }
                    }
                }

            };
            const updatedAreas = [...areas, newArea].sort((a, b) => {
                const orderA = parseInt(a.order, 10) || parseInt(a.id, 10) || 9999;
                const orderB = parseInt(b.order, 10) || parseInt(b.id, 10) || 9999;
                return orderA - orderB;
            });
            setAreas(updatedAreas);
        } else {
            let maxWidth, maxHeight;
            if (currentAspectRatio) {
                const aspectKey = `${currentAspectRatio.width}:${currentAspectRatio.height}`;

                if (COMMON_ASPECT_RATIOS[aspectKey]) {
                    maxWidth = COMMON_ASPECT_RATIOS[aspectKey].width;
                    maxHeight = COMMON_ASPECT_RATIOS[aspectKey].height;
                } else {
                    maxWidth = currentAspectRatio.width;
                    maxHeight = currentAspectRatio.height;
                }
            }

            const newArea = {
                unit: "px",
                id: newId,
                name: `Screen ${newId}`,
                start_margin: 0,
                top_margin: 0,
                width: maxWidth,
                height: maxHeight,
                order: newId,
                settings: {
                    live: {
                        is_muted: 0,
                        maintain_aspect_ratio: 1,
                        order: newId,
                        media_animation: {
                            type: "FADE",
                            enabled: false,
                            duration: 0.5,
                            direction: "CENTER"
                        }
                    }
                }
            };
            const updatedAreas = [...areas, newArea].sort((a, b) => {
                const orderA = parseInt(a.order, 10) || parseInt(a.id, 10) || 9999;
                const orderB = parseInt(b.order, 10) || parseInt(b.id, 10) || 9999;
                return orderA - orderB;
            });
            setAreas(updatedAreas);
        }

        // تطبيق اللون العشوائي والـ opacity الافتراضي (40%)
        if (setAreaColor) setAreaColor(newId, randomColor);
        if (setAreaOpacity) setAreaOpacity(newId, DEFAULT_OPACITY);
    };

    return <Button label={t('layouts.designer_add_area')} icon="fas fa-plus" className={"    p-2    text-[15px] bg-blue text-white"} onClick={() => handleAddArea()} />;
};

export default AddArea;
